import { useEffect, useState } from 'react';
import * as durationPlugin from 'dayjs/plugin/duration';
import * as dayjs from 'dayjs';

dayjs.extend(durationPlugin);

type UseTimerArgs = {
  initialStart?: boolean

  // Duration object or number of seconds
  initialTime: durationPlugin.Duration | number;
  intervalSeconds?: number;
};
type UseTimer = (args: UseTimerArgs) => {
  duration: durationPlugin.Duration;
  timeSeconds: number;
  start: () => void;
  stop: () => void;
  reset: () => void;
  isRunning: boolean;
};

export const useTimer: UseTimer = ({
  initialStart = false,
  initialTime,
  intervalSeconds = 1,
}) => {
  const initialDuration = dayjs.isDuration(initialTime)
    ? initialTime
    : dayjs.duration(initialTime * 1000);
  const [duration, setDuration] = useState(initialDuration);
  const [isRunning, setIsRunning] = useState(initialStart);

  const start = () => {
    setIsRunning(true);
  };

  const stop = () => {
    setIsRunning(false);
  };

  const reset = () => {
    setDuration(initialDuration);
    start();
  };

  useEffect(() => {
    let intervalId: number;
    if (isRunning) {
      intervalId = window.setInterval(
        () => {
          setDuration(
            (prevDuration) => {
              const newDuration = prevDuration.subtract(
                dayjs.duration({ seconds: intervalSeconds }),
              );
              if (newDuration.asSeconds() <= 0) {
                stop();
                return dayjs.duration(0);
              }
              return newDuration;
            },
          );
        },
        intervalSeconds * 1000,
      );
    }
    return () => {
      window.clearInterval(intervalId);
    };
  }, [isRunning, intervalSeconds]);

  return {
    duration,
    timeSeconds: duration.asSeconds(),
    start,
    stop,
    reset,
    isRunning,
  };
};
